// collectionEntitySlice.ts
import { createEntityAdapter, createSlice } from '@reduxjs/toolkit';
import { Collection } from '../types';

//~ Keep a reference to this slice's name for cleanup in case of persistReducer usage
export const name = 'collections';

//~ Initialize your state here
const collectionsAdapter = createEntityAdapter<Collection>();

interface CollectionState
    extends ReturnType<typeof collectionsAdapter.getInitialState> {
    selectedCollectionId: string;
}

const initialState: CollectionState = {
    selectedCollectionId: '',
    ...collectionsAdapter.getInitialState(),
};

export const collectionSlice = createSlice({
    name,
    initialState,
    reducers: {
        //~ Define your synchronous reducers here
        setSelectedCollectionId: (state, action) => {
            state.selectedCollectionId = action.payload;
        },
        clearSelectionCollectionId: (state) => {
            state.selectedCollectionId = '';
        },
    },
    selectors: {
        //~ Define your selectors here
        selectSelectedCollectionId: (sliceState) =>
            sliceState.selectedCollectionId,
        selectIsCollectionSelected: (sliceState) =>
            !!sliceState.selectedCollectionId,
    },
});

//~ Export defined synchronous reducers here
export const { setSelectedCollectionId, clearSelectionCollectionId } =
    collectionSlice.actions;
export const collectionSelectors = collectionsAdapter.getSelectors();

//~ Export defined selectors here
export const { selectSelectedCollectionId, selectIsCollectionSelected } =
    collectionSlice.selectors;

export const collectionReducer = collectionSlice.reducer;
export default collectionReducer;
